/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewticketall2Inputs */

const en_overviewticketall2 = /** @type {(inputs: Overviewticketall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All earnings`)
};

const de_overviewticketall2 = /** @type {(inputs: Overviewticketall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Einnahmen`)
};

/**
* | output |
* | --- |
* | "All earnings" |
*
* @param {Overviewticketall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewticketall2 = /** @type {((inputs?: Overviewticketall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewticketall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewticketall2(inputs)
	return de_overviewticketall2(inputs)
});
export { overviewticketall2 as "overviewTicketAll" }